import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "w-24 flex-center text-center whitespace-nowrap text-sm"
};
const _hoisted_2 = {
  key: 0,
  class: "flex-center flex-col"
};
const _hoisted_3 = {
  key: 0,
  class: "flex-1 flex-center uppercase text-sm text-white h-full bg-red-100"
};
const _hoisted_4 = {
  key: 2,
  class: "flex-1 flex-center uppercase text-gray-600 h-full"
};
const _hoisted_5 = {
  class: "flex-center flex-col"
};
const _hoisted_6 = {
  class: "flex flex-row -mt-1"
};
const _hoisted_7 = {
  key: 1,
  class: "h-12 w-16 rounded-xl flex-center bg-white text-xl font-mono uppercase"
};
import { app } from "@/di";
import LineupSkillCalculator from "@/modules/team/services/LineupSkillCalculator";
import PlayerForm from "@/modules/team/components/PlayerForm.vue";
import PlayerEnergy from "@/modules/team/components/PlayerEnergy.vue";
import Card from "@/modules/match/components/Card.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerSlot',
  props: {
    player: null,
    formation: null,
    position: null,
    hideForm: {
      type: Boolean
    },
    hideEnergy: {
      type: Boolean
    },
    nextMatch: null
  },
  setup(__props) {
    const props = __props;
    const isSuspended = computed(() => {
      if (!props.player) {
        return false;
      }
      if (!props.nextMatch) {
        return false;
      }
      return !!props.player.suspensions.find(s => s.competitionId === props.nextMatch.matchday.division.competitionId);
    });
    const skillCalculator = app.get(LineupSkillCalculator);
    const skillClasses = computed(() => ({
      'bg-gray-300': !props.player,
      'bg-green-500': props.player && skillCalculator.isMatching(props.player, props.formation),
      'bg-amber-500': props.player && skillCalculator.isSimilar(props.player, props.formation),
      'bg-red-500': props.player && skillCalculator.isWrong(props.player, props.formation)
    }));
    const slotClasses = computed(() => {
      if (!props.player) {
        return;
      }
      return {
        5: 'ring ring-green-200',
        4: 'ring ring-lime-200',
        3: 'ring ring-gray-200',
        2: 'ring ring-amber-200',
        1: 'ring ring-red-200'
      }[Math.ceil(props.player.energy / 20)];
    });
    const suspension = computed(() => {
      if (!props.nextMatch || !props.player) {
        return null;
      }
      return props.player.suspensions.find(s => s.competitionId === props.nextMatch.matchday.division.competitionId);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.player ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["h-7 w-16 rounded flex-center bg-white text-xl font-mono font-bold mb-1 overflow-hidden", _unref(slotClasses)])
      }, [_unref(suspension) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(Card, {
        card: _unref(suspension).card
      }, null, 8, ["card"])])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex-1 flex-center uppercase text-sm text-white h-full", _unref(skillClasses)])
      }, _toDisplayString(__props.player.position), 3)), __props.player ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(skillCalculator).calculateSkill(__props.player, __props.formation)), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: _normalizeClass(["truncate font-bold", {
          'text-red-500': _unref(isSuspended)
        }])
      }, _toDisplayString(__props.player.shortName), 3), _createElementVNode("div", _hoisted_6, [!__props.hideEnergy ? (_openBlock(), _createBlock(PlayerEnergy, {
        key: 0,
        player: __props.player,
        class: "mr-1"
      }, null, 8, ["player"])) : _createCommentVNode("", true), !__props.hideForm ? (_openBlock(), _createBlock(PlayerForm, {
        key: 1,
        player: __props.player,
        class: "mr-1"
      }, null, 8, ["player"])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.position), 1))]);
    };
  }
});